import { GET_AUDIT_DETAILS_REQUEST, GET_AUDIT_DETAILS_SUCCESS, GET_AUDIT_DETAILS_FAILED, GET_AUDIT_DETAILS_RESET } from "../types"

const initialState = {
	auditDetailsList: [],
	isAuditDetailsLoading: false,
	auditError: null,
}
// eslint-disable-next-line
export default function (state = initialState, action) {
	switch (action.type) {
		case GET_AUDIT_DETAILS_REQUEST:
			return {
				...state,
				isAuditDetailsLoading: action.payload,
			}
		case GET_AUDIT_DETAILS_SUCCESS:
			return {
				...state,
				isFromEmailsLoading: false,
				auditDetailsList: action.payload,
				auditError: null,
			}
		case GET_AUDIT_DETAILS_FAILED:
			return {
				...state,
				isAuditDetailsLoading: false,
				auditError: action.payload,
			}
		case GET_AUDIT_DETAILS_RESET:
			return {
				...state,
				auditDetailsList: [],
			}
		default:
			return state
	}
}
